/**
 * Pinia Documentation
 *
 * @link https://pinia.vuejs.org/introduction.html
 */
import {defineStore} from "pinia";

import state from "./modules/trial-listing/state";
import trialListingActions from "./modules/trial-listing/actions";

export const trialListingStore = defineStore(
    'trialListingStore',
    {
        state,
        actions: {
            ...trialListingActions,
        },
    }
)
